import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { Confirmation, GeneralError } from "../components";
import { parkingQuery } from "../utils/query";

export const searchParamsSchema = z.object({
  reservationId: z.string(),
});

type ConfirmationQueryProps = z.infer<typeof searchParamsSchema>;

export const confirmationQueryOptions = ({
  reservationId,
}: ConfirmationQueryProps) =>
  queryOptions({
    queryKey: ["reservation", reservationId],
    queryFn: () =>
      parkingQuery.getReservation({
        reservationId,
      }),
  });

const ConfirmationOverview = () => {
  const { t } = useTranslation();
  const search = useSearch({ from: "/confirmation" });

  const reservationQuery = useSuspenseQuery(confirmationQueryOptions(search));

  const { error, message } =
    (reservationQuery.data &&
      "error" in reservationQuery.data &&
      reservationQuery.data) ||
    {};

  return (
    <>
      {error && message && (
        <GeneralError
          className="flex-1"
          title={t("Reservation not found")}
          message={message}
        />
      )}
      {!error && !reservationQuery.isLoading && (
        <Confirmation
          reservation={
            reservationQuery.data && "id" in reservationQuery.data
              ? reservationQuery.data
              : undefined
          }
        />
      )}
    </>
  );
};

export { ConfirmationOverview };
